import React from 'react';
import styles from './card.module.css';
import CardTitle from '../../../../lib/component/cardTitle/cardTitle';
import CardItem from './cardItem/cardItem';
import { BoutiqueItem } from '../../js/interface';
import { Link } from 'react-router-dom';
import handle from '../../../../lib/handle';
import statisticsApi from '../../../../lib/statisticsApi';

export default ({ title, bookArr, button, fn }: { title: string; bookArr: BoutiqueItem[]; button: string; fn: Function | null }) => {
  const { arr1, arr2 } = handle();
  function typeText() {
    const index = arr2.indexOf(title);
    if (index >= 0) {
      return arr1[index];
    }
  }

  function tipText() {
    if (title === '包月免费读') {
      return '进入专区';
    } else if (title === '最受欢迎') {
      return '';
    } else {
      return '全部';
    }
  }

  const arr = ['畅销图书', '原创推荐', '大家都在看', '最新上架', '包月免费读', '编辑推荐', '社科', '经管', '小说', '生活', '工具'];
  const arrr: number[] = [21, 22, 23, 24, 25, 41, 42, 43, 44, 45, 46];
  function ck() {
    for (let i = 0; i < arr.length; i++) {
      if (title === arr[i]) {
        statisticsApi.statisticsApi(arrr[i]);
      }
    }
  }

  return (
    <>
      <div className={styles.card}>
        <CardTitle {...{ title: title, tip: tipText(), fn: fn }}></CardTitle>
        <div className={styles.cardContent}>
          {bookArr.map((item, index) => {
            return <CardItem {...{ ck: ck, book: item.book }} key={index}></CardItem>;
          })}
        </div>
        {button && (
          <Link to={`/shudanDetails?type=${typeText()}`}>
            <button className={styles.cardButton}>{button}</button>
          </Link>
        )}
      </div>
      {button && <div className={styles.line}></div>}
    </>
  );
};
